//====> Live urls
export const LOGIN_DOMAIN           = "https://apshclfms.apcfss.in/login";
export const live_url               = "https://api.apshclfms.apcfss.in/ofmsapi/";
export const cloud_url              = "https://api.aphousing.apcfss.in/dmsHousing/user-defined-path/file-upload/Housing"; //Live file upload url
export const cloud_url_download     = "https://api.aphousing.apcfss.in/dmsHousing/file/download?folder=Housing/";  // Live file download url
 
// ====> Dev urls
// export const LOGIN_DOMAIN           = "https://ofms.dev.nidhi.apcfss.in/login";
// export const test_url_aws           = "https://housingapi.dev.nidhi.apcfss.in/ofmsapi/";
// export const cloud_url              = "https://housingapi.dev.nidhi.apcfss.in/dmsHousing/user-defined-path/file-upload/Housing"; //Dev file upload url
// export const cloud_url_download     = "https://housingapi.dev.nidhi.apcfss.in/dmsHousing/file/download?folder=Housing/"; //Dev file download url

// ====> Local urls
// export const LOGIN_DOMAIN           = "http://localhost:3000/login"; //Local db Front End Ip
// export const system_url             = "http://192.168.1.155:8082/ofmsapi/";
export const final_url              = live_url;
 
// ====> housing urls
export const housingtest_url        = "https://housingapi.dev.nidhi.apcfss.in/reports/";
export const housinglive_url        = "https://api.aphousing.apcfss.in/reports/";
// export const housingsystem_url      = "http://192.168.0.182:8083/reports/";
export const housing_url            = housinglive_url;